import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import $ from 'jquery'
import 'jquery-qrcode'
import ElementUI from 'element-ui' //全局引入element
import 'element-ui/lib/theme-chalk/index.css' //全局引入element的样式
import '@/assets/font/fontFamily.css'
import '@/assets/font/iconfont/iconfont.css'
import '@/assets/font/iconfont/icon/iconfont.css'
import '@/utils/getConcept' //加载概念
import { linkWx } from '@/utils/linkWx.js'
Vue.prototype.$linkWx = linkWx

import GoHome from '@/components/GoHome'
import BaseTitle from '@/components/BaseTitle'
import BaseBg from '@/components/BaseBg'
import PopupDetails from '@/components/PopupDetails'
import DetailedNavigation from '@/components/DetailedNavigation'
import BasePopup from '@/components/BasePopup'
import SharePopup from '@/components/SharePopup'
import AppShare from '@/components/AppShare'
import BaseSearch from '@/components/BaseSearch'
import ScrollLoad from '@/components/ScrollLoad'
import BaseVideo from '@/components/BaseVideo'
import '@/router/permission'
Vue.component('GoHome', GoHome)
Vue.component('BaseTitle', BaseTitle)
Vue.component('BaseBg', BaseBg)
Vue.component('PopupDetails', PopupDetails)
Vue.component('DetailedNavigation', DetailedNavigation)
Vue.component('BasePopup', BasePopup)
Vue.component('SharePopup', SharePopup)
Vue.component('AppShare', AppShare)
Vue.component('ScrollLoad', ScrollLoad)
Vue.component('BaseVideo', BaseVideo)
Vue.component('BaseSearch', BaseSearch)
import '@/assets/style/reset.css'

Vue.config.productionTip = false
Vue.prototype.$ = $
// 全局事件总线
Vue.prototype.$EventBus = new Vue()

// 定义全局字符串删除HTML格式过滤器
Vue.filter('ReplaceHTMLS', function (str) {
  if (str) {
    return str.replace(/<[^>]+>/g, '')
  }
})

Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
